import React from "react";
import MDXRenderer from "gatsby-plugin-mdx/mdx-renderer";
import mdxComponents from "../components/mdxComponents";

import Layout from "../components/layout";
import config from "../../config";
import { SEO } from "../components/SEO";
import { MDXProvider } from "@mdx-js/react";
import { SignUp } from "../components/landingPage/signin";
import { graphql } from "gatsby";


const DocumentationTemplate = props => {
  const { data } = props;

  if (!data) {
    return props.children;
  }
  const { mdx } = data;

  if (!mdx) {
    return null;
  }

  // meta tags
  let meta = mdx.frontmatter;

  const metaImage = meta.metaImage ? meta.metaImage.publicURL : null;

  const metaDate = meta.date;

  let canonicalUrl = config.gatsby.siteUrl;

  canonicalUrl =
    config.gatsby.pathPrefix !== "/" ? canonicalUrl + config.gatsby.pathPrefix : canonicalUrl;
  canonicalUrl = canonicalUrl + mdx.fields.slug;

  return (
    <Layout {...props}>
      <SEO metaImage={metaImage} metaDate={metaDate} metaDescription={meta.metaDescription} metaAuthor={meta.author}
           metaTitle={meta.metaTitle} canonicalUrl={canonicalUrl}/>
      <div className="mt-3">
        <h1>{mdx.fields.title}</h1>
      </div>
      <div className="mb-3">
        <div><small className="text-muted">{meta.author}</small></div>
        <div><small className="text-muted">{meta.date}</small></div>
      </div>
      <MDXProvider components={mdxComponents}><MDXRenderer>{mdx.body}</MDXRenderer></MDXProvider>
      <br />
      <hr/>
      <SignUp reference={mdx.fields.title} className="mt-5"/>
      <br className="m-5" />
    </Layout>
  );
};

export default DocumentationTemplate;

export const pageQuery = graphql`
  query($id: String!) {
    mdx(fields: { id: { eq: $id } }) {
      fields {
        id
        title
        slug
      }
      body
      tableOfContents
      parent {
        ... on File {
          relativePath
        }
      }
      frontmatter {
        metaTitle
        metaDescription
        author
        date
        metaImage
      }
    }
  }
`;
